// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__dhyj9","error":"Textarea_error__1duDJ","readonly":"Textarea_readonly__s5hsc","disabled":"Textarea_disabled__2j171"};